// <showroom-countdown data-wedding-date="YYYY-MM-DD">: days until the
// wedding, "Today" on the day and "Congratulations" afterwards. Counted in
// the shopper's own timezone, so it's done client-side.

class ShowroomCountdown extends HTMLElement {
  connectedCallback() {
    const [year, month, day] = (this.dataset.weddingDate || "").split("-").map(Number);
    if (!year || !month || !day) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const daysLeft = Math.round((new Date(year, month - 1, day) - today) / 86400000);
    const days = this.querySelector("[data-countdown-days]");
    const label = this.querySelector("[data-countdown-label]");

    if (daysLeft > 0) {
      days.textContent = daysLeft;
      return;
    }

    days.textContent = daysLeft === 0 ? this.dataset.localeToday : this.dataset.localePast;
    label.hidden = true;
    this.classList.add("is-message");
  }
}

if (!customElements.get("showroom-countdown")) {
  customElements.define("showroom-countdown", ShowroomCountdown);
}
